import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Mail20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.79688 3C1.11553 3 0.5 3.53491 0.5 4.27083V15.7292C0.5 16.4651 1.11553 17 1.79688 17H18.2031C18.8845 17 19.5 16.4651 19.5 15.7292V4.27083C19.5 3.53491 18.8845 3 18.2031 3H1.79688ZM2 6.30968V15.5H18V6.30954L9.99991 12.9763L2 6.30968ZM17.8284 4.5H2.17146L9.99991 11.0237L17.8284 4.5Z'
      fill='currentColor'
    />
  </Svg>
);

Mail20.displayName = 'Mail20';
export default Mail20;
